<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="dynamicValidateForm" :model="dynamicValidateForm" v-bind="formItemLayoutWithOutLabel">
            <draggable v-model=" dynamicValidateForm.domains" group="people" @start="drag=true" @end="drag=false"  :options="{animation: 60,handle:'.drag'}">
            <div class="item flex" :key="index"  v-for="(domain, index) in dynamicValidateForm.domains">
                <img src="../../../../assets/drag.png" alt="" class="drag">
                <div class="left">
                <a-upload
                        :action=" action "
                        :data="{type:1}"
                        :file-list="domain.fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file,index)}"
                         :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="domain.fileList==null||domain.fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
                </div>
                <div class="right">
                <a-form-model-item
                        v-bind=" formItemLayout  "
                        label="图片标题"
                        :prop="'domains.' + index + '.title'"
                >
                    <a-input :maxLength=110  v-model="domain.title"   style="width: 60%; margin-right: 8px"  />
                </a-form-model-item>
                    <a-form-model-item
                            v-bind=" formItemLayout  "
                            label="Alt属性"
                            :prop="'domains.' + index + '.alt'"
                    >
                        <a-input :maxLength=110  v-model="domain.alt"   style="width: 60%; margin-right: 8px" />
                    </a-form-model-item>
                    <a-form-model-item
                            v-bind=" formItemLayout  "
                            label="链接"
                            :prop="'domains.' + index + '.href'"
                            :rules="{type:'url', message:'请填写正确链接地址',trigger:'blur'}"
                    >
                        <a-input :maxLength=200 v-model="domain.href"  style="width: 60%; margin-right: 8px" />
                    </a-form-model-item>
                </div>
                <a-icon
                        v-if="dynamicValidateForm.domains.length > 1"
                        class="dynamic-delete-button"
                        type="minus-circle-o"
                        :disabled="dynamicValidateForm.domains.length === 1"
                        @click="removeDomain(domain)"
                />
            </div>
            </draggable>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel" v-if="dynamicValidateForm.domains.length <6">
                <a-button type="dashed" style="width: 60%" @click="addDomain">
                    <a-icon type="plus" /> 添加banner图
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >
            <a-button type="primary"  html-type="submit" @click="submitForm('dynamicValidateForm')">
            确认
        </a-button>
            <a-button @click="onClose()" style="margin-left: 10px">
                取消
            </a-button>

        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,beforeUpload} from "../../../../utils/utils"
    import API from "../api";
    import draggable from 'vuedraggable'
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "advertisingForm",
        props: ["visible","title","editId"],
        data() {
            return {
                id:null,
                dataJson:{
                    id:"",
                    banner:[]
                },
                action:this.$store.state.urlChang,
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                previewVisible: false,
                previewImage: '',
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 20 },
                    },
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        xs: { span: 24, offset: 0 },
                        sm: { span: 20, offset: 4 },
                    },
                },
                dynamicValidateForm: {
                    domains: [{
                        title: "",
                        alt: "",
                        href: "",
                        key: Date.now(),
                        fileList:[],
                    }],
                },
                drawerConfig ,
            };
        },
        components: {
            draggable
        },
        watch:{
            editId: function (a, b) {
                let _this=this
                if (a != "") {
                    _this.dataJson.id=a
                    _this.getImg(a)
                }
            }
        },
        methods: {

            getImg(id){
                API.advertisingManagement.EDIT_DATA( id ).then(res => {
                    if(res.data.data.list.length>0){
                        res.data.data.list.map((item,index)=>{
                            item.fileList=[
                                {
                                    uid: item.img_url,
                                    name:item.img_url,
                                    status: "done",
                                    url:item.img_url
                                }
                            ]

                        })
                        this.dynamicValidateForm.domains= res.data.data.list
                    }

                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            handleChange(info,index ) {
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    this.dynamicValidateForm.domains[index].fileList=[]
                }
                if (status === 'done') {
                    this.dynamicValidateForm.domains[index].fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.dynamicValidateForm.domains[index].fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.dynamicValidateForm.domains[index].fileList= fileList
                    });
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
               return beforeUpload(file)
            },
            submitForm(formName) {
                let _this=this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let domainsData=JSON.parse(JSON.stringify(this.dynamicValidateForm.domains))
                        let Arr=[];
                        domainsData.map((item,index)=>{
                            if(item.fileList!=null&&item.fileList.length>0&&item.fileList[0].url){
                                item.img_url=item.fileList[0].url;
                                item.fileList=[];
                                delete item["key"];
                                Arr.push(item)
                            }else if(item.fileList!=null&&item.fileList.length>0&&item.fileList[0].response){
                                item.img_url=item.fileList[0].response.data.url;
                                item.fileList=[];
                                delete item["key"]
                                Arr.push(item)
                            }
                        })
                        let jsona={}
                        let Arra=[];
                        Arr.map((item,index)=>{
                            let{img_url,title,alt,href}=item
                            jsona={ img_url,title,alt,href }
                            Arra=[...Arra,jsona]
                        })
                        _this.dataJson.banner=Arra
                        let url="/admin/ABanner/addpost"
                        submitForm(API.advertisingManagement.SUBMIT_ADD , _this.dataJson).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            removeDomain(item) {
                let index = this.dynamicValidateForm.domains.indexOf(item);
                if (index !== -1) {
                    this.dynamicValidateForm.domains.splice(index, 1);
                }
            },
            addDomain() {
                this.dynamicValidateForm.domains.push({
                    title: "",
                    alt: "",
                    href: "",
                    key: Date.now(),
                    fileList:[],
                });
            },

            onClose() {
                this.$emit("changVisible", false);
                this.dynamicValidateForm.domains=[]
            },
            // submitForm(formName) {
            //     let _this = this;
            //     this.$refs[formName].validate(valid => {
            //         if (valid) {
            //             let Arr=[]
            //             this.dynamicValidateForm.domains.map((item,index)=>{
            //                 if(this.item.fileList.length>0&&this.fileList[0].url){
            //                     this.item.url=this.fileList[0].url
            //                     Arr.push(item)
            //                 }else if(this.fileList.length>0&&this.fileList[0].response){
            //                     this.item.url=this.fileList[0].response.data.url
            //                     Arr.push(item)
            //                 }
            //             })
            //             console.log(Arr)
            //             return
            //             let url
            //             this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT
            //             submitForm(url, _this.form).then(res => {
            //                 if (res == true) {
            //                     this.onClose()
            //                 } else {
            //                     res.map((item, index) => {
            //                         this.formErr[item.field] = item.msg
            //                     })
            //                 }
            //             })
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },
        },
    }
</script>

<style scoped>
.item.flex{margin-bottom: 30px;position: relative}
.item.flex .left{width: 20%;margin-left: 5%}
.item.flex .right{width:75%}
.ant-form-item{margin-bottom: 0!important;}
.ant-upload.ant-upload-select-picture-card{margin-top: 10px!important;}
.dynamic-delete-button{position: absolute;right:10%;top:40px}
.drag{position: absolute;left:0;top:30px;display: inline-block;width: 10px;cursor: pointer}
</style>
